<template> 
     <BaseModal
        :id="'static'"
        :title="title"
        message="When you select a supervisor, the associates list will be updated to show only those who report directly to the selected supervisor."
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0 mt-2" @submit.prevent="form_submit_local()">
                <div class="schedule-form shadow p-3 mb-3 mt-3 bg-white rounded">
                    <div class="schedule-form__day p-2">
                        <div class="formdynamic__item__field">
                            <label for="assignment" class="modal-label">Day: <b style='color:red;'>*</b></label>
                            <select size="" required="required" class="input-field custom-select" id="assignment" v-model="form_data.rotation_day_id">
                                <option value="" v-html="'Select an option'" />
                                <option :value="item.id" v-for="(item, index) in form_data.rotation_days" :key="index" v-html="used_in == 'master_days_off' ? item.day_number : item.day_date" />
                            </select>
                        </div>
                    </div>
                    <div class="schedule-form__supervisor p-2">
                        <div class="formdynamic__item__field">
                            <label for="assignment" class="modal-label">Supervisor: </label>
                            <select size="" class="input-field custom-select" id="assignment" v-model="form_data.supervisor_id">
                                <option value="" v-html="'Select an option'" />
                                <option :value="item.id" v-for="(item, index) in array_options['supervisor_id']" :key="index" v-html="item.name" />
                            </select>
                        </div>
                    </div>
                    <div class="schedule-form__assignment p-2">
                        <div class="formdynamic__item__field">
                            <label for="assignment" class="modal-label">Assignment: <b style='color:red;'>*</b></label>
                            <select required="required" class="input-field custom-select" id="assignment" v-model="form_data.assignment_id">
                                <option value="" v-html="'Select an option'" />
                                <option :value="item.id" v-for="(item, index) in daily_assignment_options" :key="index" v-html="item.name" />
                            </select>
                        </div>
                    </div>
                    
                    <div class="schedule-form__associate p-2">
                        <div class="formdynamic__item__field">
                            <label for="assignment" class="modal-label">Associate: <b style='color:red;'>*</b></label>
                            <select size="" required="required" class="input-field custom-select" id="assignment" v-model="form_data.associate_id">
                                <option value="" v-html="'Select an option'" />
                                <option :value="item.id" v-for="(item, index) in filtered_associates" :key="index" v-html="item.name" />
                            </select>
                        </div>
                    </div>
                    <div class="schedule-form__button">
                        <button class="modal__buttons__item w-auto px-3" v-html="'Add'" type="button" :class="{'disabled button__disabled' : !filled_data}" :disabled="!filled_data" @click="addRecord()"/>
                    </div>
                </div>
                <div class="row" style="padding-top:10px;">
                    <table class="table">
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">Assignment</th>
                            <th scope="col">Associate</th>
                            <th scope="col">Day</th>
                            <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody v-if="form_data.new_associates.length">
                            <tr v-for="(item, index) in form_data.new_associates" :key="index">
                                <th v-html="index + 1"/>
                                <td v-html="item.assignment"/>
                                <td v-html="item.associate"/>
                                <td v-html="item.rotation_day"/>
                                <td>
                                    <button
                                        type="button"
                                        class="modal__buttons__item cancel mt-0 ml-0"
                                        v-html="`Remove`"
                                        style="width: 4rem"
                                        @click="removeRecord(index)"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <CentralButtons/>
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources  from './form_resources'
import Breadcrumb     from '@/components/BreadcrumbComponent/Breadcrumb'
import CentralButtons from '@/components/CentralButtons'
import BaseModal      from '@/components/BaseModal'

export default {

    name:   'FormModal',

    props: [
        'title',
        'rest_api',
        'notyf',
        'parent',
        'form_data',
        'form_backup',
        'array_options',
        'schedule_options',
        'daily_assignment_options',
        'breadcrumb',
        'schedules',
        'rotation',
        'next_start_date',
        'used_in'
    ],

    components:{
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format: FormResources.form_format,
            
        }
    },

    watch:
    {
        parent(val)
        {
            this.form_data.rotation_setup_id = val.id
        },

        async 'form_data.supervisor_id' (val)
        {
            if(val)
            {
                this.form_data.associate_id = ''
            }
        }

    },

    methods:{
        form_submit_local()
        {
            let http_request= {
                rotation_id: this.rotation.rotation_setup_id,
                new_associates: this.form_data.new_associates,
                date: this.next_start_date
            }
            this.form_submit(undefined, http_request)

        },

        removeRecord(index)
        {
            this.form_data.new_associates.splice(index, 1)
        },

        addRecord()
        {
            if(this.form_data.rotation_day_id && this.form_data.assignment_id && this.form_data.associate_id)
            {
                const find_day =  this.form_data.rotation_days.find(item => item.id == this.form_data.rotation_day_id);
                let day = '';

                if(find_day)
                {
                    if(this.used_in == 'master_days_off')
                    {
                        day = find_day.day_number
                    }
                    else
                    {
                        day = find_day.day_date
                    }
                }

                this.form_data.new_associates.unshift(
                    {
                        rotation_day_id: this.form_data.rotation_day_id,
                        order_day: this.form_data.rotation_days.findIndex(item => item.id == this.form_data.rotation_day_id),
                        assignment_id: this.form_data.assignment_id,
                        associate_id: this.form_data.associate_id,
                        associate: this.array_options['associate_id'].find(item => item.id == this.form_data.associate_id).name,
                        assignment: this.daily_assignment_options.find(item => item.id == this.form_data.assignment_id).name,
                        rotation_day: day
                    }
                )
            }
        }

    },

    mounted(){
    },  


    computed:
    {
        filled_data()
        {
            if(this.form_data.rotation_day_id && this.form_data.assignment_id && this.form_data.associate_id)
            {
                return true
            }

            return false
        },

        filtered_associates()
        {
            let associates = this.array_options['associate_id']

            if(this.form_data.supervisor_id)
            {
                return associates.filter(item => item.supervisor_id == this.form_data.supervisor_id)
            }

            return associates
        }
    }
}

</script>